import React from 'react'
import { View, Text } from 'react-native'
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import Button from '../../../components/Button';
import UserAvatar from '../../../components/Users/UserAvatar';
import CachedImage from '../../../components/CachedImage';
import Images from '../../../constants/Images';
import styles from './styles';

export const ImageChange = ({ item, acceptChange, rejectChange }) => {

  const accept = () => {
    console.log('accept()');
    acceptChange(item);
  }
  const reject = () => {
    console.log('reject()');
    rejectChange(item);
  }

  return (
    <View>
      {/* <Text style={[CS.smallTitle, CS.lightText]}>Photo</Text> */}
      <View style={[CS.rowContainer, { marginBottom: 20 }]}>
        <UserAvatar userId={item.avatar.id} avatar={item.avatar.version} size='medium' />
        <Text style={[CS.smallText, CS.lightBlueText, { marginLeft: 10 }, CS.flex]}>{item.memo}</Text>
      </View>
      <CachedImage source={{ uri: item.path }} style={[styles.img, { aspectRatio: Images.project.width / Images.project.height }]} />
      <View style={styles.caption}>
        <Text style={[CS.smallText, CS.lightBlueText, CS.centerText]}>{item.caption}</Text>
      </View>
      <View style={[CS.rowContainer, { marginBottom: 10} ]}>
        <View style={CS.buttonLeft}>
          <Button text='Accept' onPress={() => accept} />
        </View>
        <View style={CS.buttonRight}>
          <Button text='Reject' onPress={() => reject} color='red' />
        </View>
      </View>
    </View>
  );
}

export default ImageChange;